import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeadsInformation = _resolveComponent("LeadsInformation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LeadsInformation, {
        enquiryID: _ctx.projectDetails.enquiryID,
        clientName: _ctx.projectDetails.clientName,
        status: _ctx.projectDetails.status,
        salesman: _ctx.projectDetails.salesman,
        businessArea: _ctx.projectDetails.businessArea,
        projectDescription: _ctx.projectDetails.projectDescription,
        projectValue: _ctx.projectDetails.projectValue,
        basecampProjectID: _ctx.projectDetails.basecampProjectID,
        providerAccountID: _ctx.providerAccountId
      }, null, 8, ["enquiryID", "clientName", "status", "salesman", "businessArea", "projectDescription", "projectValue", "basecampProjectID", "providerAccountID"])
    ])
  ]))
}